import { Link } from "react-router-dom";
import { encyclopediaCards, categories } from "@/mocks/home";

export default function EncyclopediaSection() {
  return (
    <section className="px-6 md:px-10 py-14 md:py-18 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-book-open-line mr-1.5"></i>
            黑料百科
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            吃瓜也要
            <span className="text-accent-500">有深度</span>
            ，懂八卦更要
            <span className="text-primary-500">懂门道</span>
          </h2>
        </div>

        {/* Encyclopedia Cards - Asymmetric Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-14">
          {/* Large card - left */}
          {encyclopediaCards
            .filter((card) => card.isLarge)
            .map((card) => (
              <Link
                key={card.id}
                to={`/article/${card.slug}`}
                className="group relative w-full aspect-[4/3] lg:aspect-auto rounded-xl overflow-hidden cursor-pointer"
              >
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.title} - 黑料百科`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block text-xs font-medium text-background-50/80 bg-black/30 backdrop-blur-sm px-2.5 py-1 rounded-md mb-3">
                    {card.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-white mb-2 leading-snug">
                    {card.title}
                  </h3>
                  <div className="flex items-center gap-3">
                    <span className="text-xs text-white/60">{card.readingTime} 阅读</span>
                    <span className="text-xs text-primary-400 flex items-center gap-1">
                      立即阅读
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}

          {/* Right stack - two smaller cards */}
          <div className="flex flex-col gap-5">
            {encyclopediaCards
              .filter((card) => !card.isLarge)
              .map((card) => (
                <Link
                  key={card.id}
                  to={`/article/${card.slug}`}
                  className={`group flex flex-col sm:flex-row rounded-xl overflow-hidden cursor-pointer ${
                    card.colorClass || "bg-background-100"
                  }`}
                >
                  <div className="sm:w-2/5 relative aspect-[4/3] sm:aspect-auto overflow-hidden">
                    <img
                      src={card.image}
                      alt={card.title}
                      title={`${card.title} - 黑料百科`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                    <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-200/50 px-2 py-0.5 rounded-md mb-2.5 w-fit">
                      {card.category}
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                      {card.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                      {card.excerpt}
                    </p>
                    <span className="text-xs text-foreground-400">{card.readingTime} 阅读</span>
                  </div>
                </Link>
              ))}
          </div>
        </div>

        {/* Categories Navigation */}
        <div className="border-t border-background-200/70 pt-10">
          <h3 className="font-heading text-lg font-semibold text-foreground-950 text-center mb-6">
            浏览更多标签
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-all duration-200 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500 text-sm`}></i>
                </div>
                {cat.name}
                <span className="text-xs text-foreground-400 ml-1">{cat.count}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}